export default {
  bankInfo(state) {
    return state.bankInfo;
  }
};
